import cloneDeep from 'lodash/cloneDeep';
import store from '@/store/store';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import * as devisConf from '@/configuration/devisConf';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import { getCompletReseauNumeriqueAsync } from '@/api/reseauxNumerique';
import { getProduitAssocie, /* getProduitLocation */ getAllProduitLocations } from '@/api/devis';
import { gestionLiaisonsTarifProduitsAssocies } from '@/services/devis/gestionProduitsAssocies';
import calculDateFin from '@/services/general/calculDateFin';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import * as produitConf from '@/configuration/produitConf';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import updateQuantiteLiaisonTarif from '@/services/devisCommandes/updateQuantiteLiaisonTarif';
import * as saturationConvertisseur from '@/services/devisCommandes/numerique/saturationConvertisseur';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

async function generationLigneCommandeRegroupement(
  produitReseau,
  produitsAssocies,
  periode,
  datePremiereAffichage,
  reseau,
  listIdProduits,
  tauxTvaDefault,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande, tauxTvaDefault);
  nouvelleLigneCommande.title = produitsAssocies && produitsAssocies.libelle
    ? produitReseau.reference + ' - ' + produitsAssocies.libelle : produitReseau.reference;
  nouvelleLigneCommande.produitId = produitReseau.id;
  nouvelleLigneCommande.typeProduit = produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE;
  nouvelleLigneCommande.produit = {};
  nouvelleLigneCommande.tauxTva = 0;
  if (reseau.periodeCal) {
    nouvelleLigneCommande.dateDebut = reseau.periodeCal.debut;
    nouvelleLigneCommande.dateFin = reseau.periodeCal.fin;
  } else {
    nouvelleLigneCommande.dateDebut = datePremiereAffichage || new Date();
    nouvelleLigneCommande.dateFin = calculDateFin(
      nouvelleLigneCommande.dateDebut, 1, devisConf.ANNEE,
    );
  }
  nouvelleLigneCommande.libelle = produitReseau.libelle;
  nouvelleLigneCommande.masqueLigne = false;
  nouvelleLigneCommande.type = devisConf.REGROUPEMENT;
  if (produitsAssocies && produitsAssocies.produitEnfant) {
    await gestionLiaisonsTarifProduitsAssocies(
      produitsAssocies, reseau, listIdProduits, produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE);
    nouvelleLigneCommande.lignesCommande = await generationToutesLignesCommandes(
      produitsAssocies, reseau.extensionOpportunite.typeDeRemise, tauxTvaDefault,
    );
  } else nouvelleLigneCommande.lignesCommande = [];
  return nouvelleLigneCommande;
}

async function ajoutLignesCommandeProduitReseauNumeriqueViaObject(
  devisCommande,
  produitReseau,
  produitAssocie,
  ordre,
  periode,
  reseau,
  listIdProduits,
  tauxTvaDefault,
) {
  let liaisonTarif = [];
  if (produitAssocie !== null) {
    if (periode && periode.dateDebut) {
      const liaisonTarifTempo = returnLiaisonTarif(
        produitReseau, produitAssocie.id, new Date(periode.dateDebut),
      );
      liaisonTarif = cloneDeep(liaisonTarifTempo);
      updateQuantiteLiaisonTarif(liaisonTarif, periode.dateDebut, periode.dateFin);
      if (liaisonTarif && liaisonTarif.quantiteAjustee) {
        liaisonTarif.quantite = liaisonTarif.quantiteAjustee;
      }
    } else {
      const liaisonTarifTempo = returnLiaisonTarif(produitReseau, produitAssocie.id,
        new Date());
      liaisonTarif = cloneDeep(liaisonTarifTempo);
    }

    // cas où le produit de location n'est pas mis par défaut
    if (!liaisonTarif) {
      const liaisonTarifTempo = genererLiaisonTarifFromProduitAssocie(
        produitAssocie, periode,
      );
      liaisonTarif = cloneDeep(liaisonTarifTempo);
    }
  }
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitReseau,
    liaisonTarif,
    periode,
    devisCommande.datePremierAffichage,
    reseau,
    listIdProduits,
    tauxTvaDefault,
  );
  if (periode && periode.saturation) {
    nouvelleLignesCommande.quantiteDispo = saturationConvertisseur
      .toQuantiteDispo(periode.saturation);
  }
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  return nouvelleLignesCommande;
}

export default async function ajoutLignesCommandeProduitReseauNumeriqueViaId(
  devisCommande, reseau, listIdProduits, ordre, tauxTvaDefault,
) {
  let saturation = null;
  const produitReseau = (await getCompletReseauNumeriqueAsync(reseau.num)).data.result;
  let produitAssocie = null;
  let idProduitDefault = produitReseau.produitReseauNumerique.produitParDefautId;
  if (idProduitDefault === null) {
    idProduitDefault = listIdProduits.produit;
  }
  if (idProduitDefault) {
    produitAssocie = (await getProduitAssocie(idProduitDefault))
      .data.result;
    if (produitAssocie.supportCommercial.categorieVente === produitConf.CATEGORIE_LOCATION) {
      const idSociete = store.getters['user/idSociete'];
      const queryItem = {
        query: {
          numerique: true,
          societeId: idSociete,
        },
        sorting: 'CreationTime DESC',
        maxResultCount: 999999,
      };
      const produitLocNum = (await getAllProduitLocations(queryItem)).data.result.items;
      const produitLoc = produitLocNum.find(el => el.id === produitAssocie.id);
      saturation = produitLoc.produitLocation.saturation;
    }
  }
  return ajoutLignesCommandeProduitReseauNumeriqueViaObject(
    devisCommande,
    produitReseau,
    produitAssocie,
    ordre,
    { saturation: saturation },
    reseau,
    listIdProduits,
    tauxTvaDefault,
  );
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/ajoutProduitReseauNumerique.js